import React, { useState, useEffect } from 'react';
import { appointmentStatusToString } from '../helpers/Helpers';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { SERVER_URL } from '../constants';
import CommonSnackbar from './CommonSnackbar';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(0),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

// Default status options
const defaultStatusOptions = [
  { value: 1, label: "Confirmed" },
  { value: 2, label: "Cancelled" },
  { value: 5, label: "No Show" },
  { value: 4, label: "Done" },
];

function OfficeTodaysFixedScheduleStatusChange(props) {
  const [open, setOpen] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(props.customerAppointment.status);
  const [saving, setSaving] = useState(false);
  const [disableSaveButton, setDisableSaveButton] = useState(true);

  const snackbar = {
    errorTitle,
    errorMessage,
    setErrorTitle,
    setErrorMessage,
  };

  useEffect(() => {
    if (open || props.openStatusChangeModal) {
      handleOpen();
    }
  }, [open, props.openStatusChangeModal]);

  const handleOpen = () => {
    setSelectedStatus(props.customerAppointment.status);
    setDisableSaveButton(true);
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "backdropClick") return; // ignore backdrop clicks
    props.setOpenStatusChangeModal(false);
    setOpen(false);
  };

  const handleChange = (event) => {
    setSelectedStatus(event.target.value);
    setDisableSaveButton(false);
  };

  const handleConfirm = () => {
    setStatus();
  };

  const setStatus = () => {
    setSaving(true);
    const token = sessionStorage.getItem("token");
    fetch(
      SERVER_URL + 'api/mod/update-appointment-status/' + props.customerAppointment.office_id,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + token,
        },
        body: JSON.stringify({
          id: props.customerAppointment.id,
          status: selectedStatus,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 1) {
          props.fetchTimeSlotList();
          handleClose();
          setErrorTitle("Message");
          setErrorMessage(data.message);
        } else {
          setErrorTitle("Error");
          setErrorMessage(data.message);
        }
        setSaving(false);
      })
      .catch((err) => console.error(err));
  };

  // Use parent-provided options if available, otherwise fall back to defaults
  const statusOptions = props.statusOptions || defaultStatusOptions;

  return (
    <React.Fragment>
      <CommonSnackbar snackbar={snackbar} />

      <BootstrapDialog
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "500px",
            },
          },
        }}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open || props.openStatusChangeModal}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          <Stack direction="column" justifyContent="center" alignItems="flex-start" spacing={0}>
            <Typography sx={{ lineHeight: 1.2 }} variant="body1">
              Update Status
            </Typography>
            <Typography sx={{ lineHeight: 1.2 }} variant="h6">
              {props.customerAppointment.name}
            </Typography>
            <Typography sx={{ lineHeight: 1.2 }} variant="body1">
              status: {appointmentStatusToString(props.customerAppointment.status)}<br />
            </Typography>
          </Stack>
        </DialogTitle>

        <DialogContent sx={{ m: 0, p: 2 }} dividers={true}>
          <Stack spacing={2} padding={2}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Change Status to</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedStatus}
                label="Change Status to"
                onChange={handleChange}
              >
                {statusOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={disableSaveButton || saving} onClick={handleConfirm}>
            Save
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}

export default OfficeTodaysFixedScheduleStatusChange;